import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { uniqueIdForComponent, ICON_SIZES, sizeForIcon } from '../util';
var propTypes = {
  /** id for the icon */
  id: PropTypes.string,

  /** title of the icon */
  title: PropTypes.string,

  /** path for the icon */
  path: PropTypes.string,

  /** path node for the icon */
  pathNode: PropTypes.node,

  /** size of the icon. one of 'small', 'medium' */
  size: PropTypes.oneOf(ICON_SIZES),

  /** additional styling class name */
  className: PropTypes.string,

  /**
   size multiplier used to provide custom icon size, small size 16 x multiplier
   */
  sizeMultiplier: PropTypes.number,

  /** specifies if the icon is selected */
  selected: PropTypes.bool,

  /** changes the direction of the icon in RTL mode */
  directional: PropTypes.bool,

  /** used by screen readers to describe a non-decorative icon */
  ariaLabel: PropTypes.string,

  /** decorative icons are hidden from screen readers, ariaLabel not required */
  decorative: PropTypes.bool
};
var defaultProps = {
  ariaLabel: undefined,
  title: undefined,
  path: undefined,
  pathNode: undefined,
  id: undefined,
  size: 'small',
  className: undefined,
  sizeMultiplier: 1,
  selected: false,
  directional: true,
  decorative: false
};

var Icon = /*#__PURE__*/function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon(props) {
    var _this;

    _classCallCheck(this, Icon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icon).call(this, props));
    _this.state = {
      id: props.id || uniqueIdForComponent(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          id = _this$props.id,
          ariaLabel = _this$props.ariaLabel,
          path = _this$props.path,
          pathNode = _this$props.pathNode,
          size = _this$props.size,
          sizeMultiplier = _this$props.sizeMultiplier,
          className = _this$props.className,
          selected = _this$props.selected,
          directional = _this$props.directional,
          decorative = _this$props.decorative,
          otherProps = _objectWithoutProperties(_this$props, ["title", "id", "ariaLabel", "path", "pathNode", "size", "sizeMultiplier", "className", "selected", "directional", "decorative"]);

      var titleId = "".concat(this.state.id, "-description");
      var iconSize = sizeForIcon(size);
      var customSize = sizeForIcon('small') * sizeMultiplier;
      var stylingClass = classnames('wds-c-icon', "wds-c-icon-".concat(iconSize), {
        'wds-c-icon--selected': selected
      }, {
        'wds-c-icon--directional': directional
      }, className);
      var customIconSizeStyle = {
        width: customSize,
        height: customSize
      };

      if (!path && !pathNode) {
        console.warn('Icon component needs either a path or a pathNode prop');
        return null;
      } // TODO: remove alt attribute when ruleset 2018AugustDeploy used


      return React.createElement("svg", _extends({
        className: stylingClass,
        id: this.state.id,
        focusable: "false"
      }, title && {
        'aria-labelledby': titleId
      }, ariaLabel && {
        'aria-label': ariaLabel
      }, {
        alt: ariaLabel
      }, decorative ? {
        'aria-hidden': true
      } : {
        role: 'img'
      }, otherProps, sizeMultiplier > 1 && {
        style: customIconSizeStyle
      }), title && React.createElement("title", {
        id: titleId
      }, title), path ? React.createElement("use", {
        xlinkHref: path
      }) : pathNode && pathNode);
    }
  }]);

  return Icon;
}(React.Component);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
Icon.displayName = 'Icon';
export default Icon;